import React from "react";
 
const OverviewPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>Project Overview</h1>
 
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, width: "160px" }}>Step ID</th>
              <th style={{ ...styles.th, width: "230px" }}>Role</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
 
          <tbody>
 
            <tr>
              <td style={styles.td}>1. User Registration</td>
              <td style={styles.td}>PROJECT COORDINATOR</td>
              <td style={styles.td}>
                • Onboard users - Maker(s), checker(s), Issuer, Vendor(s)<br />
                • Notification is sent to User’s email with credentials
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>2. Create Project</td>
              <td style={styles.td}>PROJECT COORDINATOR</td>
              <td style={styles.td}>
                • The PROJECT_COORDINATOR enters the details of the Project and assigns registered actors to specific roles.<br />
                • For Department, mapping Maker-Checker pairs need to be mapped<br />
                • Notification email will be sent to the MAKERs
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>3. Upload Beneficiary List</td>
              <td style={styles.td}>MAKER</td>
              <td style={styles.td}>
                • The MAKER uploads the list of beneficiaries for the project. The format is an excel sheet.<br />
                • A sample sheet can be downloaded from this page for reference.<br />
                • Email Notification will be sent to the CHECKER of that Department.
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>4. Approve Beneficiary List</td>
              <td style={styles.td}>CHECKER</td>
              <td style={styles.td}>
                • Verify the beneficiary details and approve few or all of them
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>5. Issue voucher to beneficiary</td>
              <td style={styles.td}>ISSUER</td>
              <td style={styles.td}>
                • Validates the beneficiary list from all the departments, and the vendor list<br />
                • Approve few or all of them and issue vouchers<br />
                • Vouchers will be sent as SMS to the approved beneficiaries
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>6. Project Dashboard</td>
              <td style={styles.td}>PROJECT COORDINATOR / ADMIN / OBSERVER</td>
              <td style={styles.td}>
                • View the status of vouchers for the project<br />
                • Observer such as company secretary banker ca and officials can use dashboard print reports for associated purpose such as payment to vendor , analytics and feedback and improvement
              </td>
            </tr>
 
            <tr>
              <td style={styles.td}>7. User Dashboard</td>
              <td style={styles.td}>OBSERVER / ADMIN</td>
              <td style={styles.td}>
                • View the details of all the actors for the project
              </td>
            </tr>
 
          </tbody>
        </table>
 
      </div>
    </div>
  );
};
 
const styles = {
  container: {
    padding: "10px",
    backgroundColor: "#f4f6f8",
    minHeight: "calc(100vh - 80px)",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "30px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    color: "#333",
    marginBottom: "25px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  },
  th: {
    backgroundColor: "#e3f2fd",
    border: "1px solid #ccc",
    padding: "12px",
    fontWeight: "bold",
    fontSize: "16px",
    textAlign: "center",
  },
  td: {
    border: "1px solid #ccc",
    padding: "12px",
    verticalAlign: "top",
    backgroundColor: "#fafafa",
    wordWrap: "break-word",
    fontSize: "13px",
    lineHeight: "19px",
  },
};
 
export default OverviewPage;
 
 